export enum GlobalDataConstants {
  IS_GLOBAL_DATA_LOADING = 'globalData/IS_GLOBAL_DATA_LOADING',
  ON_GLOBAL_DATA_IMPORT_SUCCESS = 'globalData/ON_GLOBAL_DATA_IMPORT_SUCCESS',
}
